import ReactRailsUJS from 'react_ujs'
import { viteConstructorRequireContext } from '../helpers/ViteHelper'
import baseFrontModules from '../helpers/entrypoint_modules/baseFront'

import mountEditAssemblyCardInstance from '../helpers/mountEditAssemblyCardInstance'

mountEditAssemblyCardInstance()

const contextsCms = import.meta.globEager(['~/components/cms/**/*.{js,jsx,ts,tsx}'])

const contexts = Object.assign(contextsCms, baseFrontModules)

ReactRailsUJS.getConstructor = viteConstructorRequireContext(contexts)
